import * as React from 'react';

export interface IDateCellProps {
  text: string;
  title: string;
}

export function DateCell({ text, title }: IDateCellProps) {
  return <span title={title}>{text}</span>;
}
